
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.333 16.667v-5.834h-1.666v5.834H3.333V3.333h5.834V1.667H3.333c-.92 0-1.666.746-1.666 1.666v13.334c0 .92.746 1.666 1.666 1.666h13.334c.92 0 1.666-.746 1.666-1.666zM15.982 2.27a2.045 2.045 0 00-2.902 0L6.104 9.246a3.373 3.373 0 00-1.102 2.245L5 14.168v.833h3.446c.945-.065 1.77-.477 2.352-1.149l6.935-6.931a2.051 2.051 0 000-2.902l-1.751-1.75zM8.387 13.337c.445-.031.86-.238 1.192-.619l5.052-5.051-2.296-2.296-5.088 5.087c-.338.299-.547.716-.58 1.099v1.779l1.72.001zm5.127-9.144l2.295 2.295.745-.745a.385.385 0 000-.544l-1.753-1.753a.38.38 0 00-.54 0l-.747.747z","fill":"#fff"}})])
          )
        }
      }
    